import React from 'react';
import { Card, CardContent } from './ui/card';

export const AnimatedCard = ({ children, delay = 0, className = '' }) => {
  return (
    <Card
      className={`animate-on-scroll opacity-0 bg-[rgba(30,64,98,0.7)] border border-[#00a8ff] rounded-xl backdrop-blur-sm hover:shadow-[0_0_30px_#00a8ff] transition-all duration-500 hover:-translate-y-2 ${className}`}
      style={{
        transitionDelay: `${delay}ms`,
        transform: 'translateY(30px)',
        boxShadow: '0 0 15px rgba(0,168,255,0.3)'
      }}
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-[#00a8ff] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" style={{ boxShadow: '0 0 10px #00a8ff' }}></div>
      <CardContent className="p-8">
        {children}
      </CardContent>
    </Card>
  );
};